<template>
    <div>
        <slot :manual-link="manualLink"></slot>
    </div>
</template>

<script>
import {checkAppEnv} from '@shared/utils/common';

export default {
    name: 'HMCManual',
    computed: {
        is_theme_env() {
            // custom prd-theme 에선 빌드 env 비교였지만 단일 빌드에선 테넌트 판정으로 흡수
            return checkAppEnv() === 'hmc-theme';
        },
        manualLink() {
            if (this.$i18n.locale === 'ko' && this.ko_manual_url) {
                return this.ko_manual_url;
            } else if (this.$i18n.locale === 'en' && this.en_manual_url) {
                return this.en_manual_url;
            } else if (this.$i18n.locale === 'ca' && this.ca_manual_url) {
                return this.ca_manual_url;
            }
            return this.ko_manual_url;
        },
        ko_manual_url() {
            if (this.is_theme_env) {
                return '/document/manual/hmg/2026_현대차기아_공급망_ESG_테마평가_시스템_사용_매뉴얼_국문.pdf';
            }
            return '/document/manual/hmg/2025_현대차기아_공급망_평가_시스템_사용_매뉴얼_국문.pdf';
        },
        en_manual_url() {
            if (this.is_theme_env) {
                return '/document/manual/hmg/2026_HMG_Supply_Chain_Theme_Assessment_System_User_Manual_Eng.pdf';
            }
            return '/document/manual/hmg/2025_HMG_Supply_Chain_Assessment_System_User_Manual_Eng.pdf';
        },
        ca_manual_url() {
            if (this.is_theme_env) {
                return '/document/manual/hmg/2026年HMG供应链ESG主题评估系统指南.pdf';
            }
            return '/document/manual/hmg/2025_HMG_供應鏈評估系統使用手冊_中文.pdf';
        },
    },
};
</script>
